import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteNombreCentreRequest: ['response'],
    deleteNombreCentreSuccess: ['response', 'loading'],
    deleteNombreCentreFailure: ['error'],
})

export const deleteNombreCentreTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    success: null,
    response: null,
    error: null,
})

/* ------------- Reducers ------------- */

const deleteNombreCentreRequest = state => state.merge({ success: null })

const deleteNombreCentreSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteNombreCentreFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_NOMBRE_CENTRE_REQUEST]: deleteNombreCentreRequest,
    [Types.DELETE_NOMBRE_CENTRE_SUCCESS]: deleteNombreCentreSuccess,
    [Types.DELETE_NOMBRE_CENTRE_FAILURE]: deleteNombreCentreFailure,
})
